import styled from 'styled-components';

import { INDICATOR_SIZE } from '../../Stepper.constants';

export const Container = styled.div`
  display: grid;
  grid-column-gap: 8px;
  grid-template-columns: ${INDICATOR_SIZE} 1fr;

  box-sizing: border-box;
  position: relative;

  padding-top: ${({ first }) => {
    let result = '4px';

    if (first) {
      result = '0';
    }

    return result;
  }};
  padding-bottom: ${({ last }) => {
    let result = '4px';

    if (last) {
      result = '0';
    }

    return result;
  }};
`;

export const Indicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;

  width: ${INDICATOR_SIZE};
  height: ${INDICATOR_SIZE};

  position: relative;

  border: 2px solid
    ${({ active, fulfilled }) => {
      let result = 'var(--color-grey-3)';

      if (fulfilled) {
        result = 'var(--color-black)';
      } else if (active) {
        result = 'var(--color-grey-4)';
      }

      return result;
    }};
  border-radius: ${INDICATOR_SIZE};

  background-color: ${({ fulfilled }) => {
    let result = 'var(--color-white)';

    if (fulfilled) {
      result = 'var(--color-black)';
    }

    return result;
  }};

  &:before,
  &:after {
    content: '';

    position: absolute;

    width: 100%;
    height: 4px;

    background-color: var(--color-white);
  }

  &:before {
    top: -6px;
  }

  &:after {
    bottom: -6px;
  }
`;

export const Title = styled.p`
  font: var(--font-regular-15);
  font-weight: ${({ active }) => {
    let result = '500';

    if (!active) {
      result = '400';
    }

    return result;
  }};

  margin: 0;

  color: ${({ active }) => {
    let result = 'var(--color-grey-12_30)';

    if (active) {
      result = 'var(--color-black)';
    }

    return result;
  }};
`;
